import { Paper, Table, Text } from '@mantine/core'
import { TransferByLocationResponse } from '../../../data/hostDashboard.service'
import { COLORS } from '../../../utils/constants'
import { formatNumber } from '../../../utils/displayUtils'

type EarningsByLocationListProps = {
  locations: TransferByLocationResponse[]
}

const EarningsByLocationList = ({ locations }: EarningsByLocationListProps) => (
  <Paper shadow='xs' radius='md' p={0} withBorder>
    <Table verticalSpacing='xs' highlightOnHover>
      <Table.Tbody>
        {locations.map((loc) => (
          <Table.Tr key={loc.locationName}>
            <Table.Td>
              <Text fw={600} fz='sm'>
                {loc.locationName}
              </Text>
            </Table.Td>
            <Table.Td align='right'>
              <Text fw={700} fz='md' c={COLORS.LightGreen}>
                ${formatNumber(loc.hostShare)}
              </Text>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  </Paper>
)

export default EarningsByLocationList
